import {useGetPendingReviewsQuery} from "@/graphql/graphql.ts";
import {useState} from "react";
import {SimpleZyusetuListView} from "@/components/pages/Zyusetu/SimpleZyusetuListView.tsx";
import {Container} from "@mui/material";

export function ZyusetuReviewListPage() {
  const [page, setPage] = useState(1);
  const itemsPerPage = 6;
  const {data: zyusetu, isLoading} = useGetPendingReviewsQuery({
    skip: (page - 1) * itemsPerPage,
    take: itemsPerPage,
  })
  return <>
    
    <Container maxWidth="lg">
      <SimpleZyusetuListView
        title="あなたのレビュー待ちの重説"
        zyusetus={zyusetu?.getPendingReviews || {items: [], total: 0}}
        itemsPerPage={itemsPerPage}
        handlePageChange={(_, value) => setPage(value)}
        getLink={(zyusetu) => `/zyusetu/reviews/${zyusetu.approvalStepExecutionId}`}
        page={page}
        isLoading={isLoading}
      />
    </Container>
  </>
}
